import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Category } from '@/types/article';
import { useToast } from '@/hooks/use-toast';

export function useCategoryManagement() {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const createCategory = async (name: string, description?: string): Promise<Category | null> => {
    setLoading(true);
    try {
      const slug = name.toLowerCase().replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-');
      
      const { data, error } = await supabase
        .from('categories')
        .insert({
          name,
          slug,
          description
        })
        .select()
        .single();

      if (error) throw error;

      toast({
        title: "Success",
        description: "Category created successfully"
      });

      return data as Category;
    } catch (error) {
      console.error('Error creating category:', error);
      toast({
        title: "Error",
        description: "Failed to create category",
        variant: "destructive"
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    createCategory,
    loading
  };
}